const axios = require('axios');
module.exports.init = me => {
  me.getTags = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/blog/tags`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data,
        meta
      } = response.data.data;
      on_success(data, meta);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.getCategories = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/blog/categories`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data,
        meta
      } = response.data.data;
      on_success(data, meta);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.getPosts = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/blog/posts`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data,
        meta
      } = response.data.data;
      on_success(data, meta);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.getPost = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/blog/post/${data.id}`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.getComments = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/blog/comments`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.postComment = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/blog/comments/store`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.blogLog = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/logs/send`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
};